import { render, staticRenderFns } from "./FaveLocationModal.vue?vue&type=template&id=a65f0f70&scoped=true&"
import script from "./FaveLocationModal.vue?vue&type=script&lang=js&"
export * from "./FaveLocationModal.vue?vue&type=script&lang=js&"
import style0 from "./FaveLocationModal.vue?vue&type=style&index=0&id=a65f0f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65f0f70",
  null
  
)

export default component.exports